import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface SplitRowProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

export function SplitRow({children, className, 'data-testid': testId}: SplitRowProps) {
    return (
        <div
            className={cn('flex items-center justify-between flex-wrap gap-4', className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
